module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill=\"#9B9B9B\" fill-rule=\"evenodd\" d=\"M12 7V1H8v6H5l5 5 5-5h-3zm5.327 4.418A1.503 1.503 0 0 0 16.285 11h-1.757l3.064 2.994h-3.544a.274.274 0 0 0-.24.133L12.992 16H7.008l-.816-1.873a.276.276 0 0 0-.24-.133H2.408L5.471 11H3.715c-.397 0-.776.159-1.042.418-.4.392-1.801 1.891-2.011 2.114-.489.521-.758.936-.63 1.449l.561 3.074c.128.514.691.936 1.252.945h16.312c.561-.009 1.124-.431 1.252-.945l.561-3.074c.126-.513-.142-.928-.632-1.449-.21-.224-1.611-1.723-2.011-2.114z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-file-download.svg
// module id = 872
// module chunks = 1